import { DateTimeFormatter } from "@js-joda/core";

export const DateTimeSubmissionFormat = DateTimeFormatter.ofPattern(
  "yyyy-MM-dd HH:mm:ss",
);
export const DateSubmissionFormat = DateTimeFormatter.ofPattern("yyyy-MM-dd");
